import angular from "angular";
import HeaderItem from "./header-item.component"

export default angular.module("vui-header-item.module", [])
    .component('vuiHeaderItem', HeaderItem);
